if (!customElements.get('blog-container')) {
  customElements.define(
    'blog-container',
    class BlogContainer extends HTMLElement {
      connectedCallback() {
        const activeIndex = parseInt(this.dataset.activeSlide) || 0;
        const carouselId = this.dataset.carouselId;
        const wrapper = this.querySelector('[data-blog-filter-wrapper]');
        const carousel = this.querySelector(`[data-external-nav-buttons="${carouselId}"]`);
        if (!carousel || !wrapper) return;

        this.revealWhenReady(carousel, wrapper, activeIndex);
      }

      revealWhenReady(carousel, wrapper, index) {
        if (carousel.swiper) {
          if (index > 0) carousel.swiper.slideTo(index, 0);
          requestAnimationFrame(() => {
            wrapper.style.transition = 'opacity 0.2s ease';
            wrapper.style.opacity = '1';
          });
        } else {
          requestAnimationFrame(() => this.revealWhenReady(carousel, wrapper, index));
        }
      }
    }
  );
}
